import "./MobileMenuItem.css"
import React, { useRef, useState } from "react";

type Props = React.HTMLAttributes<HTMLDivElement>;

export function MobileMenuItem({ className = "", onClick, ...rest }: Props) {
    const [pressed, setPressed] = useState(false);
    const start = useRef({ x: 0, y: 0 });
    const moved = useRef(false);

    const THRESH = 8;

    const onPointerDown: React.PointerEventHandler<HTMLDivElement> = (e) => {
        if (e.pointerType !== "touch") return; // روی موبایل
        start.current = { x: e.clientX, y: e.clientY };
        moved.current = false;
        setPressed(true);
    };

    const onPointerMove: React.PointerEventHandler<HTMLDivElement> = (e) => {
        if (e.pointerType !== "touch" || !pressed) return;
        const dx = Math.abs(e.clientX - start.current.x);
        const dy = Math.abs(e.clientY - start.current.y);
        if (dx > THRESH || dy > THRESH) {
            moved.current = true;
            setPressed(false);
        }
    };

    const onPointerUp: React.PointerEventHandler<HTMLDivElement> = (e) => {
        if (e.pointerType === "touch") {
            setTimeout(() => setPressed(false), 60);
            if (!moved.current) {
                onClick?.(e);
            }
            return;
        }
        onClick?.(e);
    };

    const onPointerCancel: React.PointerEventHandler<HTMLDivElement> = () => {
        setPressed(false);
    };

    return (
        <div
            className={`mobile-menu-item ${pressed ? "pressed" : ""} ${className}`}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
            onPointerCancel={onPointerCancel}
            role="button"
            tabIndex={0}
            {...rest}
        />
    );
}
